import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  authorization,
} from '../../mock';
import {
  acceptedRoundTripJourneys,
  chargeableSeatsToPayForRoundTripJourney,
  firstCHSeatOnRoundTripJourney,
  firstFreeSeatOnRoundTripJourney,
  noItemToPayError,
  paymentRecords,
  roundTripBoardingPassResult,
  roundTripJourneys,
  roundTripSeatmap,
} from '../../mock/data';

/**
 * RT 3 journeys with 1 ADT, 1 CHD, 1 INF with the 3rd journey containing both the bounds
 */
export const rt3Journeys1Adt1Chd1InfCheckin: MockMap = {
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [
    createMockDataWithResponse(roundTripBoardingPassResult, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [
    createMockData(chargeableSeatsToPayForRoundTripJourney),
    createMockData(chargeableSeatsToPayForRoundTripJourney),
    createMockData(chargeableSeatsToPayForRoundTripJourney),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError)
  ],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(roundTripJourneys, 201),
    createMockDataWithResponse(acceptedRoundTripJourneys, 201)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnRoundTripJourney[0], 201),
    createMockDataWithResponse(firstFreeSeatOnRoundTripJourney[0], 201)
  ],
  updateJourneyElement: [
    createMockData(firstCHSeatOnRoundTripJourney[0])
  ],
  retrieveJourney: [
    createMockData(acceptedRoundTripJourneys[2])
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(roundTripSeatmap)]
};
